export const featured = {
  4: {
    '0x67f22c4a30bfcc57ab6840c3e51ef35da40c989c': true
  }
};
